module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBold-965633ee2786e697aad1fbabc51daee4.woff";